import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Grid } from '@material-ui/core';
import { Form, notification, Button, Input, InputNumber, Switch } from 'antd';
import MainContainer from '../../components/MainContainer';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { green } from '@material-ui/core/colors';

@inject(
  'CmsPaymentTypeStore',
  'CmsLanguageStore'
)
@observer
class CmsPaymentType extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {
    this.props.CmsLanguageStore.getActives().then(() => {
      this.props.CmsPaymentTypeStore.getData();
    });
  }

  create = () => {
    this.props.CmsPaymentTypeStore.create().then(resp => {
      if (!resp.isError) {
        this.props.CmsPaymentTypeStore.getData();
        notification['success']({
          message: 'Success',
          description: 'Payment Type is successfully updated.',
          duration: 1
        });
      }
    });
  }

  update = (id) => {
    this.props.CmsPaymentTypeStore.update(id).then(resp => {
      if (!resp.isError) {
        this.props.CmsPaymentTypeStore.getData();
        notification['success']({
          message: 'Success',
          description: 'Payment Type is successfully updated.',
          duration: 1
        });
      }
    });
  }

  delete = (id) => {
    this.props.CmsPaymentTypeStore.delete(id).then(resp => {
      if (!resp.isError) {
        this.props.CmsPaymentTypeStore.getData();
        notification['success']({
          message: 'Success',
          description: 'Payment Type is successfully deleted.',
          duration: 1
        });
      }
    });
  }

  render() {
    const {
      activeLanguages
    } = this.props.CmsLanguageStore;

    const {
      data,
    } = this.props.CmsPaymentTypeStore;

    return (
      <MainContainer title='Customize Payment Type' menukey='cms-payment-type'>
        <>
          {
            activeLanguages
              ?
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Form.Item>
                    <div style={{ textAlign: 'right' }}>
                      <button
                        style={{ border: 'none', background: 'none', cursor: 'pointer' }}
                        onClick={() => this.props.CmsPaymentTypeStore.initCreate(activeLanguages)}>
                        <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                      </button>
                    </div>
                    <div className='stm-display-flex stm-stm-width-100-percent stm-background-white-three stm-font-size-14 stm-line-height-18 stm-font-weight-bold stm-color-495057 stm-border-bottom-width-2 stm-border-bottom-color-white-two stm-border-bottom-style-solid'>
                      <div className='stm-width-20-percent stm-padding-8'>No Post</div>
                      <div className='stm-width-10-percent stm-padding-8'>Sort</div>
                      <>
                        {
                          activeLanguages.map(lang => {
                            return (
                              <div key={lang.id} className='stm-width-20-percent stm-padding-8'>{lang.name}</div>
                            )
                          })
                        }
                      </>
                      <div className='stm-width-20-percent stm-padding-8'>Action</div>
                    </div>
                    <>
                      {
                        data.map(item => {
                          return (
                            <>
                              <div
                                key={item.id}
                                className='stm-display-flex stm-stm-width-100-percent  stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two  stm-border-top-style-solid stm-background-white'
                              >
                                <div className='stm-width-10-percent stm-padding-8'>
                                  <Switch
                                    checkedChildren='Yes'
                                    unCheckedChildren='No'
                                    checked={item.noPost}
                                    onChange={(value) => this.props.CmsPaymentTypeStore.setnoPost(item.id, value)} />
                                </div>
                                <div className='stm-width-10-percent stm-padding-8'>
                                  <InputNumber
                                    min={0}
                                    value={item.sort}
                                    onChange={(value) => this.props.CmsPaymentTypeStore.setsort(item.id, value)}
                                    className='stm-width-64' />
                                </div>
                                <>
                                  {
                                    activeLanguages.map(lang => {
                                      return (
                                        <div className='stm-width-20-percent stm-padding-8'>
                                          <Input
                                            value={item.paymentTypeLanguages.find(fi => fi.languageId === lang.id).name}
                                            onChange={(e) => this.props.CmsPaymentTypeStore.setname(item.id, lang.id, e.target.value)}
                                            className='' />
                                        </div>
                                      )
                                    })
                                  }
                                </>
                                <div className='stm-width-20-percent stm-padding-8'>
                                  <>
                                    {
                                      item.id === 0
                                        ?
                                        <>
                                          <Button
                                            type='primary'
                                            className='stm-font-size-16 line-height-20 stm-width-100 stm-height-32 stm-margin-right-16'
                                            onClick={this.create}>Create</Button>
                                          <Button
                                            type='default'
                                            className='stm-font-size-16 line-height-20 stm-width-100 stm-height-32'
                                            onClick={() => this.props.CmsPaymentTypeStore.cancel()}>Cancel</Button>
                                        </>
                                        :
                                        <>
                                          <Button
                                            type='primary'
                                            className='stm-font-size-16 line-height-20 stm-width-100 stm-height-32 stm-margin-right-16'
                                            onClick={() => this.update(item.id)}>Edit</Button>
                                          <>
                                            {
                                              item.id === 1
                                                ?
                                                null
                                                :
                                                <Button
                                                  type='danger'
                                                  className='stm-font-size-16 line-height-20 stm-width-100 stm-height-32'
                                                  onClick={() => this.delete(item.id)}>Delete</Button>
                                            }
                                          </>
                                        </>
                                    }

                                  </>
                                </div>
                              </div>
                            </>
                          )
                        })
                      }
                    </>
                  </Form.Item>
                </Grid>
              </Grid>
              :
              null
          }
        </>
      </MainContainer>
    )
  }
}

export default CmsPaymentType;